import { Mapper } from '@base/mapper';
import { TravelPlanModel, TravelPlanState } from '@domain/models/travel-plan.model';
import { TravelPlanEntity } from '../entities/travel-plan-entity';

export class TravelPlanMapper extends Mapper<
  TravelPlanEntity,
  TravelPlanModel
> {
  override mapFrom(param: TravelPlanEntity): TravelPlanModel {
    return {
      ...param,
      state: TravelPlanState[param.state as keyof typeof TravelPlanState],
    };
  }

  override mapTo(param: TravelPlanModel): TravelPlanEntity {
    throw new Error('Method not implemented.');
  }
}
